// @ts-nocheck
class LasiriusAvizeSelector extends HTMLElement {
  connectedCallback() {
    this.form = this.closest('form');
    this.steps = [...this.querySelectorAll('[data-avize-step]')];
    this.radios = [...this.querySelectorAll('input[type="radio"]')];
    this.message = this.querySelector('[data-avize-message]');
    this.submitButton = this.form?.querySelector('[data-avize-submit]');
    this.buyNowButton = this.form?.querySelector('[data-avize-buy-now]');
    this.inventoryDisabled = this.submitButton?.dataset.inventoryDisabled === 'true';

    if (this.steps.length > 1) {
      this.steps.slice(1).forEach((step) => step.removeAttribute('open'));
    }

    this.radios.forEach((radio) => {
      radio.addEventListener('change', () => this.handleChange(radio));
    });
    this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
    this.buyNowButton?.addEventListener('click', (event) => this.handleBuyNow(event));
    this.update();
  }

  handleChange(radio) {
    const step = radio.closest('[data-avize-step]');
    const nextStep = step?.nextElementSibling;
    if (nextStep?.matches('[data-avize-step]')) {
      nextStep.setAttribute('open', '');
    }
    this.update();
  }

  handleSubmit(event) {
    const firstMissing = this.steps.find((step) => !step.querySelector('input:checked'));
    if (!firstMissing) return;

    event.preventDefault();
    firstMissing.setAttribute('open', '');
    firstMissing.querySelector('input')?.focus();
    if (this.message) {
      this.message.textContent = 'Lütfen her gövde için bir renk seçin.';
    }
  }

  async handleBuyNow(event) {
    event.preventDefault();
    const firstMissing = this.steps.find((step) => !step.querySelector('input:checked'));
    if (firstMissing) {
      firstMissing.setAttribute('open', '');
      firstMissing.querySelector('input')?.focus();
      if (this.message) {
        this.message.textContent = 'Lütfen her gövde için bir renk seçin.';
      }
      return;
    }

    if (this.buyNowButton) {
      this.buyNowButton.disabled = true;
      this.buyNowButton.textContent = 'Yönlendiriliyor...';
    }

    try {
      const formData = new FormData(this.form);
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      if (!response.ok) {
        throw new Error(`Cart add failed: ${response.status}`);
      }

      window.location.href = '/checkout';
    } catch (error) {
      console.error('Avize buy now redirecting fallback:', error);
      let returnInput = this.form.querySelector('input[name="return_to"]');
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';
        this.form.appendChild(returnInput);
      }
      this.form.submit();
    }
  }

  update() {
    let completeCount = 0;
    this.steps.forEach((step) => {
      const checked = step.querySelector('input:checked');
      const index = step.dataset.avizeStep;
      const status = step.querySelector('[data-avize-step-status]');
      const summary = this.querySelector(`[data-avize-summary="${index}"]`);
      step.toggleAttribute('data-complete', Boolean(checked));

      if (checked) completeCount += 1;
      if (status) status.textContent = checked ? checked.value : 'Renk seçilmedi';
      if (summary) summary.textContent = checked ? checked.value : 'Seçilmedi';
    });

    const isComplete = completeCount === this.steps.length;
    if (this.submitButton && !this.hasAttribute('data-demo')) {
      this.submitButton.disabled = this.inventoryDisabled || !isComplete;
      this.submitButton.setAttribute('aria-disabled', String(this.inventoryDisabled || !isComplete));
    }
    if (this.buyNowButton && !this.hasAttribute('data-demo')) {
      this.buyNowButton.disabled = this.inventoryDisabled || !isComplete;
      this.buyNowButton.setAttribute('aria-disabled', String(this.inventoryDisabled || !isComplete));
    }
    if (this.message) {
      this.message.textContent = isComplete
        ? 'Seçimleriniz hazır.'
        : `Sepete eklemek için ${this.steps.length - completeCount} gövde rengi daha seçin.`;
    }
  }
}

if (!customElements.get('avize-selector')) {
  customElements.define('avize-selector', LasiriusAvizeSelector);
}

class LasiriusAvizeMediaGallery extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-avize-gallery-slide]')];
    this.thumbnails = [...this.querySelectorAll('[data-avize-gallery-thumbnail]')];
    this.lightboxSlides = [...this.querySelectorAll('[data-avize-lightbox-slide]')];
    this.counters = [...this.querySelectorAll('[data-avize-gallery-counter]')];
    this.lightbox = this.querySelector('[data-avize-gallery-lightbox]');
    this.currentIndex = 0;

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.show(Number(thumbnail.dataset.mediaIndex)));
    });
    this.querySelectorAll('[data-avize-gallery-previous]').forEach((button) => {
      button.addEventListener('click', () => this.show(this.currentIndex - 1));
    });
    this.querySelectorAll('[data-avize-gallery-next]').forEach((button) => {
      button.addEventListener('click', () => this.show(this.currentIndex + 1));
    });
    this.slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        const idx = Number(slide.dataset.mediaIndex) || 0;
        this.show(idx);
        this.openLightbox();
      });
    });
    this.querySelector('[data-avize-gallery-close]')?.addEventListener('click', () => this.lightbox?.close());
    this.addEventListener('keydown', (event) => this.handleKeydown(event));
    this.show(0);
  }

  show(index) {
    if (this.slides.length === 0) return;
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== this.currentIndex;
      slide.setAttribute('aria-hidden', String(slideIndex !== this.currentIndex));
    });
    this.lightboxSlides.forEach((slide, slideIndex) => {
      slide.hidden = slideIndex !== this.currentIndex;
    });
    this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
      const isCurrent = thumbnailIndex === this.currentIndex;
      thumbnail.setAttribute('aria-current', String(isCurrent));
      thumbnail.tabIndex = isCurrent ? 0 : -1;
    });
    this.counters.forEach((counter) => {
      counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
    });
  }

  openLightbox() {
    if (!this.lightbox) return;
    if (typeof this.lightbox.showModal === 'function') {
      this.lightbox.showModal();
    } else {
      this.lightbox.setAttribute('open', '');
    }
    this.querySelector('[data-avize-gallery-close]')?.focus();
  }

  handleKeydown(event) {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      this.show(this.currentIndex - 1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      this.show(this.currentIndex + 1);
    }
  }
}

if (!customElements.get('avize-media-gallery')) {
  customElements.define('avize-media-gallery', LasiriusAvizeMediaGallery);
}
